import {
    curationVideoPoster,
    faqPoster,
    founderStoryPoster,
    howToPoster,
    reviewPoster,
} from "../assets/contentTypes";

export interface ContentTypeConfig {
    title: string;
    description: string;
    videoUrl: string;
    posterUrl?: string;
    order: number;
}

export const CONTENT_TYPE_CONFIG: Record<string, ContentTypeConfig> = {
    "Curation Video": {
        title: "Curation Video",
        description: "Expert-selected product recommendations grouped around a theme, need, or use case.",
        videoUrl: "https://desirelist-site-videos.s3.us-east-1.amazonaws.com/Pamela-Salzman-Seasonal-Curation-Example_16x9.webm",
        posterUrl: curationVideoPoster,
        order: 4,
    },
    FAQ: {
        title: "FAQ",
        description: "Clear answers to common customer questions about a product, feature, or experience.",
        videoUrl: "https://desirelist-site-videos.s3.us-east-1.amazonaws.com/FAQ-PDP_16x9.webm",
        posterUrl: faqPoster,
        order: 3,
    },
    founder_story: {
        title: "Founder Story",
        description: "A brand-led story sharing the mission, origin, or purpose behind a product or company.",
        videoUrl: "https://desirelist-site-videos.s3.us-east-1.amazonaws.com/Leslie-Danford-FS-Vitaminis_founder-story_9042_16x9_v1.webm",
        posterUrl: founderStoryPoster,
        order: 5,
    },
    how_to: {
        title: "How To",
        description: "Step-by-step instructional content that shows customers how to use a product effectively.",
        videoUrl: "https://desirelist-site-videos.s3.us-east-1.amazonaws.com/HT-PDP-With-Graphics_16x9.webm",
        posterUrl: howToPoster,
        order: 2,
    },
    review: {
        title: "Review",
        description: "Expert-led product feedback that highlights real-world use, benefits, and key considerations.",
        videoUrl: "https://desirelist-site-videos.s3.us-east-1.amazonaws.com/PR-Sponsored_16x9.webm",
        posterUrl: reviewPoster,
        order: 1,
    },
    other: {
        title: "Other",
        description: "Custom content that does not fit a standard format but supports the product or brand goal.",
        videoUrl: "",
        order: 6,
    }
};
